import * as z from "zod/v4";

export const disconnectCreditsYardIntegration = {
  name: "disconnectCreditsYardIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
